import { type PetBreedDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/pet';
import { atom } from 'recoil';
import { getPetBreedsSelector } from '../selectors/getPetBreedsSelector';

export const petBreedsAtom = atom<PetBreedDTO[]>({
    key: 'petBreeds',
    default: getPetBreedsSelector
});
